import isString from 'lodash/isString';
import map from 'lodash/map';
import reduce from 'lodash/reduce';

const { hasOwnProperty } = Object.prototype;
const quoteReplaceRegex = /"/g;
const tabCharacter = '\t';
const carriageReturnCharacter = '\r';

export const containsExcelControlCharacters = string =>
  string.startsWith('=') ||
  string.startsWith('+') ||
  string.startsWith('-') ||
  string.startsWith('@') ||
  string.startsWith(tabCharacter) ||
  string.startsWith(carriageReturnCharacter);

export function escape(str, newLine = '\n', separator = ',') {
  if (!str) {
    return '';
  }
  if (!isString(str)) {
    return str;
  }

  const escapedStr = str.replace(quoteReplaceRegex, '""');
  if (
    str.indexOf(newLine) !== -1 ||
    str.indexOf(separator) !== -1 ||
    str.indexOf('"') !== -1 ||
    containsExcelControlCharacters(str)
  ) {
    return containsExcelControlCharacters(str)
      ? // Suppress Excel interpretting fields to avoid CSV injection (COR-49372)
        `"'${escapedStr}"`
      : `"${escapedStr}"`;
  }
  return escapedStr;
}

export function writeCsv(arrOfArrs, { newLine = '\n', separator = ',' } = {}) {
  return map(arrOfArrs, fields =>
    map(fields, field => escape(field, newLine, separator)).join(separator),
  ).join(newLine);
}

// Used when one wishes to export all keys & values from a collection of JS Objects:
export function writeCsvOfObjects(arrOfObjs, params = {}) {
  const addKeys = (memo, obj) => {
    Object.keys(obj).forEach(key => {
      memo[key] = key; // eslint-disable-line no-param-reassign
    });
    return memo;
  };

  const keyObj = reduce(arrOfObjs, addKeys, {});
  const keys = Object.keys(keyObj);
  const sortedKeys = params.sortBy ? keys.sort(params.sortBy) : keys.sort();

  // Convert to Array of Arrays. Ensure all fields are present and in a consistent order:
  const arrOfArrs = map(arrOfObjs, obj =>
    map(sortedKeys, key => (hasOwnProperty.call(obj, key) ? obj[key] : '')),
  );
  // Add keys as headers:
  arrOfArrs.unshift(sortedKeys);

  return writeCsv(arrOfArrs, params);
}

export default writeCsv;
